import { render } from "./NewCustomer.vue?vue&type=template&id=041a7f46&scoped=true"
import script from "./NewCustomer.vue?vue&type=script&lang=js"
export * from "./NewCustomer.vue?vue&type=script&lang=js"

import "./NewCustomer.vue?vue&type=style&index=0&id=041a7f46&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041a7f46"]])

export default __exports__